import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Layout from '@/layout'

export const mainRouter = [{
		path:'/',
		component: ()=> import('@/views/common/login'),
		hidden:true
	},{
		path:'/maintenance',
		component: ()=> import('@/views/common/maintenance'),
		hidden:true
	},{
		path:'/nofound',
		component: () => import('@/views/error/nofound'),
		hidden:true
	},{ 
		path:'*', 
		redirect:'/nofound', 
		hidden:true 
	},{
		path:'/home', 
		name:'sidebar.main.title',
		component: Layout,
		icon:'home',
		permission: '2916B6',
		children: [
			{
				path:'',
				name:'sidebar.main.title',
				component: ()=> import('@/views/dashboard/home'),
			}
		] 
	},{
		path:'/developer',
		name:'sidebar.developer.title',
		component: Layout,
		icon:'archive',
		permission: 'BE144D',
		children: [
			{
				path:'/developer/center',
				name:'sidebar.developer.center',				
				component: () => import('@/views/developer/center'),	
				permission: '1A629D'
			}
		]
	},{
		path:'/register',
		name:'sidebar.register.title',
		component:Layout,
		icon:'user',
		permission: 'FD069F',
		children: [
			{
				path:'/register/new',
				name:'sidebar.register.new',
				component: () => import('@/views/register/new'),	
				permission: '3AFA66'
			},{
				path:'/register/history',
				name:'sidebar.register.history',
				component: () => import('@/views/register/history'),	
				permission: 'ACE9B4'
			}
		]
	},{
		path:'/account',
		name:'sidebar.account.title',
		component:Layout,
		icon:'user-group',
		permission: '28E0CF',
		children:[
			{
				path:'/account/profile',
				name: 'sidebar.account.profile',
				component: () => import('@/views/account/profile'),	
				permission: 'AAC7C0'
			},{
				path:'/account/member',
				name: 'sidebar.account.member',
				component: () => import('@/views/account/member'),	
				permission: '8C8155'
			},{
				path:'/account/special',
				name: 'sidebar.account.special',
				component: () => import('@/views/account/special'),	
				permission: '572872'
			},{
				path:'/account/device_binding',
				name: 'sidebar.account.device_binding',
				component: () => import('@/views/account/device_binding'),	
				permission: 'D497CA'
			},{
				path:'/account/block_ip',
				name: 'sidebar.account.block_ip',
				component: () => import('@/views/account/block_ip'),	
				permission: '460FAE'
			}
		]
	},{
		path:'/site',
		name:'sidebar.site.title',
		component:Layout,
		icon:'broadcast',
		permission: 'D32BD5',
		children:[
			{
				path:'/site/news',
				name: 'sidebar.site.news',
				component: () => import('@/views/site/news'),	
				permission: 'FEA037',
			}
			// ,{
			// 	path:'/site/pool',
			// 	name: 'sidebar.site.pool',
			// 	component: () => import('@/views/site/pool'),	
			// 	permission: 'FEA037',
			// }
		]
	}
	,{
		path:'/badge',
		name:'sidebar.badge.title',
		component:Layout,
		icon:'help',
		permission: '3848BD',
		children:[
			{
				path:'/badge/list',
				name: 'sidebar.badge.list',
				component: () => import('@/views/badge/list'),	
				permission: 'C0F122',
			}
		]
	}
	,{
		path:'/rank',
		name:'sidebar.rank.title',
		component:Layout,
		icon:'jewel',
		permission: '2B74F5',
		children:[
			{
				path:'/rank/member_list',
				name: 'sidebar.rank.member_list',
				component: () => import('@/views/rank/member_list'),	
				permission: 'B99494',
			},{
				path:'/rank/special_list',
				name: 'sidebar.rank.special_list',
				component: () => import('@/views/rank/special_list'),	
				permission: '0771C5',
			}
		]
	},{
		path:'/network',
		name:'sidebar.network.title',
		component:Layout,
		icon:'network-3',
		permission: '468B47',
		children:[
			{
				path:'/network/sponsor',
				name: 'sidebar.network.sponsor',
				component: () => import('@/views/network/sponsor'),	
				permission: '992BC4',
			},{
				path:'/network/sponsor_tree',
				name: 'sidebar.network.sponsor_tree',
				component: () => import('@/views/network/sponsor_tree'),	
				permission: 'D99D59',
			}
		]
	},{
		path:'/deposit',
		name:'sidebar.deposit.title',
		component:Layout,
		icon:'store',
		permission: '10422C',
		children:[{
				path:'/deposit/request',
				name: 'sidebar.deposit.request',
				component: () => import('@/views/deposit/request'),	
				permission: '7E037C'
			},{
				path:'/deposit/address',
				name: 'sidebar.deposit.address',
				component: () => import('@/views/deposit/address'),	
				permission: 'A521B1'
			}
		]
	},{
		path:'/bonus_rate',
		name:'sidebar.bonus_rate.title',
		component:Layout,
		icon:'wallet',
		permission: 'E4C10E',
		children:[{
				path:'/bonus_rate/bonus_rate',
				name: 'sidebar.bonus_rate.bonus_rate',
				component: () => import('@/views/bonus_rate/bonus_rate'),	
				permission: 'E79CAA'
			}
		]
	},{
		path:'/transaction',
		name:'sidebar.transaction.title',
		component:Layout,
		icon:'trophy',
		permission: '0EDD5C',
		children:[
			{
				path:'/transaction/transfer',
				name: 'sidebar.transaction.transfer',
				component: () => import('@/views/transaction/transfer'),
				permission: '27D48B',	
			},{
				path:'/transaction/bonus',
				name: 'sidebar.transaction.bonus',
				component: () => import('@/views/transaction/bonus'),	
				permission: '7BE551',
			},{
				path:'/transaction/pending',
				name: 'sidebar.transaction.pending',
				component: () => import('@/views/transaction/pending'),	
				permission: 'D13BA7',
			}
			// ,{
			// 	path:'/transaction/bonus_static',
			// 	name: 'sidebar.transaction.bonus_static',
			// 	component: () => import('@/views/transaction/bonus_static'),	
			// 	permission: '2C64CC',
			// },{
			// 	path:'/transaction/pending_static',
			// 	name: 'sidebar.transaction.pending_static',
			// 	component: () => import('@/views/transaction/pending_static'),	
			// 	permission: '508024',
			// }
			,{
				path:'/transaction/withdraw',
				name: 'sidebar.transaction.withdraw',
				component: () => import('@/views/transaction/withdraw'),	
				permission: '49A927'
			},{
				path:'/transaction/complete_withdraw',
				name: 'sidebar.transaction.complete_withdraw',
				component: () => import('@/views/transaction/complete_withdraw'),	
				permission: 'A86EF7'
			},{
				path:'/transaction/trade_withdraw',
				name: 'sidebar.transaction.trade_withdraw',
				component: () => import('@/views/transaction/trade_withdraw'),	
				permission: '84AC6A'
			},{
				path:'/transaction/topup_gca',
				name: 'sidebar.transaction.topup_gca',
				component: () => import('@/views/transaction/topup_gca'),	
				permission: '3BB78B'
			}
		]
	},{
		path:'/report',
		name:'sidebar.report.title',
		component:Layout,
		icon:'graph-pie',
		permission: '0AF23D',
		children:[
			{
				path:'/report/summary',
				name: 'sidebar.report.summary',
				component: () => import('@/views/report/summary'),	
				permission: '57E182',
			},{
				path:'/report/summary_group',
				name: 'sidebar.report.summary_group',
				component: () => import('@/views/report/summary_group'),	
				permission: 'E9829C',
			}
			// ,{
			// 	path:'/report/transaction_detail',
			// 	name: 'sidebar.report.transaction_detail',
			// 	component: () => import('@/views/report/transaction_detail'),	
			// 	permission: '229AC8',
			// }
			,{
				path:'/report/member_wallet',
				name: 'sidebar.report.member_wallet',
				component: () => import('@/views/report/member_wallet'),	
				permission: '9B163D',

			},{
				path:'/report/inversetment_record',
				name: 'sidebar.report.inversetment_record',
				component: () => import('@/views/report/inversetment_record'),	
				permission: '32E04C',

			},{
				path:'/report/deposit_record',
				name: 'sidebar.report.deposit_record',
				component: () => import('@/views/report/deposit_record'),	
				permission: '79CF5A',

			},{
				path:'/report/user_list',
				name: 'sidebar.report.user_list',
				component: () => import('@/views/report/user_list'),	
				permission: 'E78D0E',

			},{
				path:'/report/system_log',
				name: 'sidebar.report.system_log',
				component: () => import('@/views/report/system_log'),	
				permission: '16F10A',
			},{
				path:'/report/price_log',
				name: 'sidebar.report.price_log',
				component: () => import('@/views/report/price_log'),	
				permission: '22A677',
			},{
				path:'/report/security',
				name: 'sidebar.report.security',
				component: () => import('@/views/report/security'),	
				permission: 'F8D04C',
			},{
				path:'/report/verify',
				name: 'sidebar.report.verify',
				component: () => import('@/views/report/verify'),	
				permission: '56874A',
			},{
				path:'/report/vrt_transaction',
				name: 'sidebar.report.vrt_transaction',
				component: () => import('@/views/report/vrt_transaction'),	
				permission: '463306',
			},{
				path:'/report/trust_out',
				name: 'sidebar.report.trust_out',
				component: () => import('@/views/report/trust_out'),	
				permission: 'D21E45',
			},{
				path:'/report/rank_report',
				name: 'sidebar.report.rank_report',
				component: () => import('@/views/report/rank_report'),	
				permission: 'A3B796',
			},{
				path:'/report/migrate_personal',
				name: 'sidebar.report.migrate_personal',
				component: () => import('@/views/report/migrate_personal'),	
				permission: 'EF36B1',
			},{
				path:'/report/migrate_group',
				name: 'sidebar.report.migrate_group',
				component: () => import('@/views/report/migrate_group'),	
				permission: '85950E',
			},{
				path:'/report/valid_downline',
				name: 'sidebar.report.valid_downline',
				component: () => import('@/views/report/valid_downline'),	
				permission: '6F2002',
			},{
				path:'/report/shopping_record',
				name: 'sidebar.report.shopping_record',
				component: () => import('@/views/report/shopping_record'),	
				permission: '6C9C42',
			},{
				path:'/report/member_log',
				name: 'sidebar.report.member_log',
				component: () => import('@/views/report/member_log'),	
				permission: '246FC5',
			},{
				path:'/report/member_trust_out',
				name: 'sidebar.report.member_trust_out',
				component: () => import('@/views/report/member_trust_out'),	
				permission: 'B248E3',
			},{
				path:'/report/gplay_topup_record',
				name: 'sidebar.report.bts_topup',
				component: () => import('@/views/report/gplay_topup_record'),	
				permission: '6A728D',
			},{
				path:'/report/gplay_withdraw_record',
				name: 'sidebar.report.bts_withdraw',
				component: () => import('@/views/report/gplay_withdraw_record'),	
				permission: 'D175D8',
			}
		]
	},{
		path:'/coin_report',
		name:'sidebar.coin_report.title',
		component:Layout,
		icon:'stack',
		permission: 'C8DC42',
		children:[
			{	
				path:'/coin_report/btc',
				name: 'sidebar.coin_report.btc',
				component: () => import('@/views/coin_report/btc'),	
				permission: '786EB3',
			},{	
				path:'/coin_report/bchabc',
				name: 'sidebar.coin_report.bchabc',
				component: () => import('@/views/coin_report/bchabc'),	
				permission: 'C23B50',
			},{	
				path:'/coin_report/eth',
				name: 'sidebar.coin_report.eth',
				component: () => import('@/views/coin_report/eth'),	
				permission: '20696B',
			},{	
				path:'/coin_report/ltc',
				name: 'sidebar.coin_report.ltc',
				component: () => import('@/views/coin_report/ltc'),	
				permission: '698699',
			},{	
				path:'/coin_report/doge',
				name: 'sidebar.coin_report.doge',
				component: () => import('@/views/coin_report/doge'),	
				permission: 'BD6F80',
			},{	
				path:'/coin_report/dash',
				name: 'sidebar.coin_report.dash',
				component: () => import('@/views/coin_report/dash'),	
				permission: '0D9CEF',
			},{	
				path:'/coin_report/usdt',
				name: 'sidebar.coin_report.usdt',
				component: () => import('@/views/coin_report/usdt'),	
				permission: '6C1DA0',
			},{	
				path:'/coin_report/gca',
				name: 'sidebar.coin_report.gca',
				component: () => import('@/views/coin_report/gca'),	
				permission: 'B867EB',
			},{	
				path:'/coin_report/migrate',
				name: 'sidebar.coin_report.migrate',
				component: () => import('@/views/coin_report/migrate'),	
				permission: '57C73F',
			},{	
				path:'/coin_report/gratis',
				name: 'sidebar.coin_report.gratis',
				component: () => import('@/views/coin_report/gratis'),	
				permission: 'A1FA19',
			}
		],
	},{
		path:'/bonus_report',
		name:'sidebar.bonus_report.title',
		component:Layout,
		icon:'blog',
		permission: '0AA5DD',
		children:[
			{	
				path:'/bonus_report/roi',
				name: 'sidebar.bonus_report.roi',
				component: () => import('@/views/bonus_report/roi'),	
				permission: '712200',
			},{	
				path:'/bonus_report/sponsor_matching',
				name: 'sidebar.bonus_report.sponsor_matching',
				component: () => import('@/views/bonus_report/sponsor_matching'),	
				permission: 'ED714F',
			}
			// ,{	
			// 	path:'/bonus_report/sponsor_share',
			// 	name: 'sidebar.bonus_report.sponsor_share',
			// 	component: () => import('@/views/bonus_report/sponsor_share'),	
			// 	permission: '3C2941',
			// }
			,{	
				path:'/bonus_report/rank_bonus',
				name: 'sidebar.bonus_report.rank_bonus',
				component: () => import('@/views/bonus_report/rank_bonus'),	
				permission: '8C7695',
			},{	
				path:'/bonus_report/rank_overriding_bonus',
				name: 'sidebar.bonus_report.rank_overriding_bonus',
				component: () => import('@/views/bonus_report/rank_overriding_bonus'),	
				permission: 'D5894A',
			},{	
				path:'/bonus_report/rank_level_matching_bonus',
				name: 'sidebar.bonus_report.rank_level_matching_bonus',
				component: () => import('@/views/bonus_report/rank_level_matching_bonus'),	
				permission: '25ECD6',
			}
			// ,{	
			// 	path:'/bonus_report/top_rank_bonus',
			// 	name: 'sidebar.bonus_report.top_rank_bonus',
			// 	component: () => import('@/views/bonus_report/top_rank_bonus'),	
			// 	permission: '7D6072',
			// }
			,{	
				path:'/bonus_report/badge_bonus',
				name: 'sidebar.bonus_report.badge_bonus',
				component: () => import('@/views/bonus_report/badge_bonus'),	
				permission: 'B93837',
			},{	
				path:'/bonus_report/badge_bonus_global',
				name: 'sidebar.bonus_report.badge_bonus_global',
				component: () => import('@/views/bonus_report/badge_bonus_global'),	
				permission: 'F741CD',
			},{	
				path:'/bonus_report/badge_bonus_release',
				name: 'sidebar.bonus_report.badge_bonus_release',
				component: () => import('@/views/bonus_report/badge_bonus_release'),	
				permission: '3D5DA8',
			}
			,{	
				path:'/bonus_report/migrate_group',
				name: 'sidebar.bonus_report.migrate_group',
				component: () => import('@/views/bonus_report/migrate_group'),	
				permission: '8326C7',
			},{	
				path:'/bonus_report/migrate_personal',
				name: 'sidebar.bonus_report.migrate_personal',
				component: () => import('@/views/bonus_report/migrate_personal'),	
				permission: 'D45215',
			}
		]
	},{
		path:'/tools',
		name:'sidebar.tools.title',
		component:Layout,
		icon:'gear',
		permission: '16E3F3',
		children:[
			{	
				path:'/tools/permission_admin',
				name: 'sidebar.tools.permission_admin',
				component: () => import('@/views/tools/permission_admin'),	
				permission: '575F48',
			},{
				path:'/tools/settings',
				name: 'sidebar.tools.settings',
				component: () => import('@/views/tools/settings'),	
				permission: '303CEA',
			},{
				path:'/tools/group',
				name: 'sidebar.tools.group',
				component: () => import('@/views/tools/group'),	
				permission: '0A738B'
			},{
				path:'/tools/system',
				name: 'sidebar.tools.system',
				component: () => import('@/views/tools/system'),	
				permission: 'AEB17F',
			},{
				path:'/tools/status',
				name: 'sidebar.tools.status',
				component: () => import('@/views/tools/status'),	
				permission: '9F2148',
			},{
				path:'/tools/attribute',
				name: 'sidebar.tools.attribute',
				component: () => import('@/views/tools/attribute'),	
				permission: 'F40E46',
			},{
				path:'/tools/package',
				name: 'sidebar.tools.package',
				component: () => import('@/views/tools/package'),	
				permission: '5CE760',
			},{
				path:'/tools/wallet',
				name: 'sidebar.tools.wallet',
				component: () => import('@/views/tools/wallet'),	
				permission: 'B428E0',
			}
			// ,{
			// 	path:'/tools/bank',
			// 	name: 'sidebar.tools.bank',
			// 	component: () => import('@/views/tools/bank'),	
			// 	permission: 'BED528',
			// }
			,{
				path:'/tools/payment',
				name: 'sidebar.tools.payment',
				component: () => import('@/views/tools/payment'),	
				permission: '0EBBAB',
			},{
				path:'/tools/bonus_payment',
				name: 'sidebar.tools.bonus_payment',
				component: () => import('@/views/tools/bonus_payment'),	
				permission: '6B0A8B',
			},{
				path:'/tools/system_payment',
				name: 'sidebar.tools.system_payment',
				component: () => import('@/views/tools/system_payment'),	
				permission: '8625EF',
			},{
				path:'/tools/email',
				name: 'sidebar.tools.email',
				component: () => import('@/views/tools/email'),	
				permission: '5284A1'
			}
			// ,{
			// 	path:'/tools/payee',
			// 	name: 'sidebar.tools.payee',
			// 	component: () => import('@/views/tools/payee'),	
			// 	permission: '6CBA9C'
			// }
			,{
				path:'/tools/coin',
				name: 'sidebar.tools.coin',
				component: () => import('@/views/tools/coin'),	
				permission: 'F24A7E',
			},{
				path:'/tools/return_message',
				name: 'sidebar.tools.return_message',
				component: () => import('@/views/tools/return_message'),	
				permission: '87B877',
			}
			,{
				path:'/tools/badge',
				name: 'sidebar.tools.badge',
				component: () => import('@/views/tools/badge'),	
				permission: '199A69'
			}
			,{
				path:'/tools/rank',
				name: 'sidebar.tools.rank',
				component: () => import('@/views/tools/rank'),	
				permission: '42A672'
			},{
				path:'/tools/version_msg',
				name: 'sidebar.tools.version_msg',
				component: () => import('@/views/tools/version_msg'),	
				permission: '6D47BD'
			},{
				path:'/tools/setting_page',
				name: 'sidebar.tools.setting_page',
				component: () => import('@/views/tools/setting_page'),	
				permission: '76B99A'
			},{
				path:'/tools/mobile_link',
				name: 'sidebar.tools.mobile_link',
				component: () => import('@/views/tools/mobile_link'),	
				permission: 'A246D6'
			},{
				path:'/tools/category',
				name: 'sidebar.tools.category',
				component: () => import('@/views/tools/category'),	
				permission: '750F55'
			}
		]
	}
];

export default new Router({
	mode: 'history',
	routes: mainRouter
});